import React from 'react';
import IconBase from './IconBase';

const TeacherIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M15.2,6.5c-1.3-0.9-3.2,0-3.2,0s-1.9-0.9-3.2,0c-1.4,0.9-1.7,3.3-0.6,5.3c0.9,1.7,2,2.1,2.4,2.2c0.6,0.1,1-0.1,1.5-0.1s0.8,0.2,1.5,0.1c0.5-0.1,1.5-0.5,2.4-2.2C16.9,9.8,16.6,7.5,15.2,6.5z"/>
            <path d="M13.4,2c-0.4,0-0.7,0.1-1.1,0.5c-0.2,0.2-0.4,0.6-0.4,1V5h1.4c0.4,0,0.7-0.1,1.1-0.5C14.8,4.2,15,3.9,15,3.4V2H13.4z"/>
            <path d="M18,15.8v2.7c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.1-0.5,0L15.7,18l-1.6,0.9c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.2-0.2-0.4v-2.8"/>
            <path d="M6.5,22C4.6,22,3,20.4,3,18.5S4.6,15,6.5,15h13.8c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H6.5c-1.1,0-2,0.9-2,2s0.9,2,2,2h13.8c0.4,0,0.8,0.3,0.8,0.8S20.7,22,20.2,22H6.5z"/>
        </IconBase>
    )
}

export default TeacherIcon;